"use client"

import { FC } from "react"
import { HeaderProps } from "./header.types";
import { EntityImage } from "@/components/ui";

const Header: FC<HeaderProps>= ({ image, title, subtitle }) => {

  return (
    <div className="transaction-context-panel-header flex flex-col items-center justify-center  space-y-2">

        {image && (
            <>
                {image.type === 'logo' || image.type === 'avatar' || image.type === 'currency' 
                    ? <EntityImage {...image} /> 
                    : image.type === 'progress' && <>Progress</>}
                <span className="text-center text-xs font-medium text-gray-500 w-full truncate">{image.label}</span>
            </>
        )}
        <h2 className={`capitalize text-center font-semibold truncate w-full`}>
            {title}
        </h2>

        <div className="flex flex-row gap-1 items-center text-xs">
            {subtitle}
        </div>
  
    </div>
  )
}

export { Header }
